/**
 * Curated display order for specific resources on /app/library when those
 * articles are present; others keep their relative order (e.g. by recency from API).
 */
export const LIBRARY_RESOURCE_PRIORITY_ORDER: readonly string[] = [
  '663fe7563cad60a4f396ba6e',
  '66403e0c32287c4873ea21be',
  '68eed393db7387914c4e2ee2',
  '68efcbfc0a270abc4ba8d820',
  '664eab630a68755ca2b130a4',
  '664eb107e91ebd8f680bd454',
  '664e9a5310c7c3486b4d3e83',
  '664eae3939d76ad018a9ab88',
  '664ece212ac37d8247e40096',
  '664ed541b1c55028e7581f98',
  '665099a5ebe651caf6e90853',
  '665091818808d05683277906',
  '664eb9e220ed2a6425812a18',
  '664ec2d35e37fb41eaa0208e',
  '666c76879e170bc865f6793b',
  '66736fd17a9534d3ab566212',
  '66e9dbc2725bf1e3e76b5100',
  '673f56fc8ea4b43fe859b0e1'
];

const priorityIndex = new Map(LIBRARY_RESOURCE_PRIORITY_ORDER.map((id, i) => [id, i]));

export function sortArticlesByLibraryPriorityOrder<T extends { articleId: string }>(articles: T[]): T[] {
  return [...articles].sort((a, b) => {
    const ia = priorityIndex.get(a.articleId);
    const ib = priorityIndex.get(b.articleId);
    if (ia !== undefined && ib !== undefined) return ia - ib;
    if (ia !== undefined) return -1;
    if (ib !== undefined) return 1;
    return 0;
  });
}
